import "./App.css";

import Home from "./home";

const App = () => {
  return (
    <div className='App'>
      <Home />
    </div>
  );
};

export default App;
